import comp from "./ParentLogin";
export default comp;
